import assert from 'http-assert-plus';
import AssetDetailsFragment from '@/graphql/fragments/AssetDetails.gql';
import axios from 'axios';
import gql from 'graphql-tag';
import mimes from 'mime-types';

const CreateAssetMutation = gql`
  ${AssetDetailsFragment}

  mutation createAsset($create: CreateAssetInput!) {
    createAsset(create: $create) {
      asset {
        ...AssetDetails
      }
      token
      upload {
        url
        headers
        body
      }
    }
  }
`;

const UploadedAssetMutation = gql`
  ${AssetDetailsFragment}

  mutation createAsset($token: String!) {
    uploadedAsset(token: $token) {
      ...AssetDetails
    }
  }
`;

export default {
  methods: {
    async createAssetMutation(create) {
      assert(create && create.fileName, 400, 'Expected asset to have a fileName');

      create.fileMime = create.fileMime || mimes.lookup(create.fileName) || null;
      assert(create.fileMime, 400, 'Expected asset to have a valid mime-type');

      const { data } = await this.$apollo.mutate({
        mutation: CreateAssetMutation,
        variables: { create },
      });

      if (data && data.createAsset && data.createAsset.token) {
        return data.createAsset;
      } else {
        return null;
      }
    },
    async initAssetUpload({ url, headers, body }, file, config) {
      const data = new window.FormData();
      Object.keys(body || {}).forEach(key => data.append(key, body[key]));
      data.append('file', file);

      return axios.request({
        method: 'POST',
        url,
        headers: headers || {},
        data,
        validateStatus: status => status === 204,
        ...config,
      });
    },
    async uploadedAssetMutation(token) {
      const { data } = await this.$apollo.mutate({
        mutation: UploadedAssetMutation,
        variables: { token },
      });

      if (data && data.uploadedAsset && data.uploadedAsset.id) {
        return data.uploadedAsset;
      } else {
        return null;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/assetUpload.js